import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/Button';
import { useAuth } from '../context/AuthContext';

export const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username || !password) return;
    setLoading(true);
    setLoginError(null);
    try {
      await login(username, password);
      navigate('/', { replace: true });
    } catch (e) {
      setLoginError((e as Error).message || 'Anmeldung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="card w-full max-w-sm">
        <h1 className="text-2xl font-bold mb-1 text-center">Kassenabrechnung</h1>
        <p className="text-sm text-slate-500 text-center mb-6">Bitte anmelden</p>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label className="label" htmlFor="login-username">Benutzername</label>
            <input
              id="login-username"
              type="text"
              className="input"
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
              disabled={loading}
            />
          </div>
          <div>
            <label className="label" htmlFor="login-password">Passwort</label>
            <input
              id="login-password"
              type="password"
              className="input"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
              disabled={loading}
            />
          </div>
          {loginError && (
            <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2">
              {loginError}
            </p>
          )}
          <Button
            variant="primary"
            type="submit"
            loading={loading}
            disabled={!username || !password}
            className="w-full justify-center mt-2"
          >
            Anmelden
          </Button>
        </form>
      </div>
    </div>
  );
};
